import React from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";

interface InputNumberProps {
  name: string;
  placeholder?: string;
  disabled?: boolean;
  type?: "number";
  className?: string;
  min?: number;
  max?: number;
  required?: boolean;
}

const InputNumber: React.FC<InputNumberProps> = ({
  name,
  placeholder = "",
  disabled = false,
  type = "number",
  className = "",
  min,
  max,
  required,
}) => {
  const [field, meta] = useField(name);

  let formGroupClass = "";
  if (meta && meta.touched) {
    if (meta.error) {
      formGroupClass = "is-invalid";
    } else {
      formGroupClass = "is-valid";
    }
  }

  const checkIfNumber = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    /**
     * Allowing: Integers | Backspace | Tab | Delete | Left & Right arrow keys
     **/

    const regex = new RegExp(
      /(^-?\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/
    );

    if (!event.key.match(regex)) {
      event.preventDefault();
    }
  };

  return (
    <>
      <Form.Control
        className={`${className} ${formGroupClass}`}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        {...field}
        value={field.value || (field.value === 0 ? 0 : "")}
        min={min}
        max={max}
        required={required}
        onKeyDown={checkIfNumber}
      />
      <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
    </>
  );
};

export default InputNumber;